import styled, { css } from 'styled-components';
import { Section } from '@/pages/CompanyReport/components/Overview/components/Section';
import { media, Grid, Text, Button } from '@simplywallst/ui-core';

export const SummarySection = styled(Section)`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 360px;

  h3 {
    margin-top: 0px;
    margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  }

  ${media.mdUp`
    padding-top: ${({ theme }) => theme.x3space}rem;
    padding-bottom: ${({ theme }) => theme.x3space}rem;
  `}
`;

export const TitleText = styled(Text)`
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const ReadMoreButton = styled(Button)`
  margin-top: ${({ theme }) => theme.x2spacePx - 4}px;
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
`;

const innerSectionCss = css`
  width: 100%;
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  background: ${({ theme }) => theme.color.phantom};
  padding: ${({ theme }) => theme.x2spacePx}px;
  height: auto;
`;

export const SnowflakeSection = styled(Grid)`
  ${innerSectionCss}
  height: auto;
`;

export const RiskRewardSection = styled('div')`
  ${innerSectionCss}
`;

export const RiskRewardWrapper = styled('div')`
  margin-top: ${({ theme }) => theme.x1spacePx}px;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  min-height: ${({ theme }) => theme.x7spacePx}px;
`;

export const RiskRewardGrid = styled(Grid)`
  height: 100%;
`;

export const SnowflakeChart = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: ${({ theme }) => theme.x2spacePx}px 0px;
`;

export const SnowflakeWrapper = styled('div')`
  width: 200px;
  max-width: 200px;
`;

export const SnowflakeTitle = styled('p')`
  margin-bottom: 0;
  opacity: 0.7;
  ${({ theme }) => theme.typography.xSmallStrong};
  width: 100%;
`;

export const SnowflakeCaption = styled('p')`
  margin-bottom: 0;
  opacity: 0.5;
  ${({ theme }) => theme.typography.xSmall};
  text-align: center;
`;

export const StyledWrapper = styled('div')`
  position: relative;
`;

export const ScrollContentWrapper = styled('div')`
  position: absolute;
  overflow-y: auto;
  height: 100%;
  width: 100%;
  padding: ${({ theme }) =>
    `0 ${theme.x3spacePx}px calc(${theme.x2spacePx}px + ${theme.safeAreaInsetBottom})`};
`;
